import { Instance, types } from 'mobx-state-tree';
import { withSetPropAction } from '@/models/helpers/withSetPropAction';
import type { PointInfoVo } from '@/apis/checkout/checkout.interface';

/**
 *
 * 积分
 *
 */
export const PointStoreModel = types
  .model('AddressStore')
  .props({
    pointInfo: types.frozen<PointInfoVo | null>(null),
  })
  .views((self) => ({}))
  .actions(withSetPropAction)
  .actions((self: any) => ({
    setPointInfo(data: PointInfoVo) {
      self.pointInfo = data;
    },
  }));

export interface PointStoreModel extends Instance<typeof PointStoreModel> {}
